import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldSearch: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-search, safety, privacy, security, scan"><path d="M3.75 5.75L12 2.25L20.25 5.75V13C20.25 17.5563 16.5563 21.25 12 21.25C7.44365 21.25 3.75 17.5563 3.75 13V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="11" cy="11" r="3.25" stroke="currentColor" strokeWidth="1.5"/><path d="M13.5 13.5L16 16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconShieldSearch;
